const initialState = {
    mailOptions: {
        website: "Frauenarztpraxis im Roten Feld",
        subject: "Anfrage über die Webseite der Frauenarztpraxis im Roten Feld",
        from: "",
        recipient: "",
        footer: "",
    },
    company: {
        title: "Ihre Frauenarztpraxis in Lüneburg",
        logo: "/images/logo_frauenarzt_lueneburg.jpg",
        logo_big: "/images/logo_frauenarzt_lueneburg-large.jpg",
        name: "",
        slogan: "",
        contact_position: "header", //header or about
        opening_times: {
            title: "Sprechzeiten",
            text: `Mo – Do: 08.00 – 13.00 Uhr <br> und 14.00 – 18.00 Uhr <br>
                Fr: 08.00 – 16.00 Uhr
                `,
        },
        spezial_times: {
            title: "Privatsprechstunde",
            tel: "04131 741 161",
        },
        address: {
            title: "So erreichen Sie uns",
            street: "Barckhausenstraße",
            number: "57",
            plz: "21335",
            ort: "Lüneburg",
            tel: "04131 741 200",
            fax: "04131 741 153",
            email: "",
            toContactForm: {
                text: "Zum Kontaktformular",
                icon: "/images/mail.png",
                hidden: true,
            },
            toJourney: {
                text: "Stellenausschreibungen",
                // icon: "/images/pin.png",
                hidden: false,
            },
        },
    },
    about_us: {
        title: "Ihre Frauenarztpraxis in Lüneburg",
        description: `<p>Wir betreiben in der Barckhausenstraße eine gut erreichbare Frauenarztpraxis ganz nah beim Lüneburger Stadtzentrum. Mit unseren Angeboten können wir Sie – unabhängig von Ihrer Lebensphase – bei den meisten gesundheitlichen Anliegen in der Frauenheilkunde oder bei einer Schwangerschaft betreuen.</p><br />`,
        image: "/images/frauenarzt_in_lueneburg_gruppenbild.jpg",
    },
    team: {
        title: "",
        members: [
            {
                firstname: "Dr. med. Regina",
                lastname: "Hoffmann",
                job: "",
                image: "/images/frauenaerztin_r_hoffmann.jpg",
                detail: "",
            },
            {
                firstname: "Dr. med. Sabine",
                lastname: "Arndt",
                job: "",
                image: "/images/frauenaerztin_s_arndt.jpg",
                detail: "",
            },
            {
                firstname: "Franziska",
                lastname: "Szuba",
                job: "",
                image: "/images/franziska_szuba.jpg",
                detail: "",
            },
            {
                firstname: "Dr. med. Sebastian",
                lastname: "Koch",
                job: "",
                image: "/images/frauenarzt_s_koch.jpg",
                detail: "",
            },
        ],
    },
    foci: [
        {
            title: "",
            short: "",
            detail: `<div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-6">
                        <b>Leistungsspektrum:</b>
                        <p>
                            Schwangerenbetreuung<br/>
                            Kinderwunschberatung<br/>
                            Sterilitätsdiagnostik<br/>
                            Krebsfrüherkennung<br/>
                            Beratung zur Empfängnisverhütung<br/>
                            Teenager-Sprechstunde, Impfberatung<br/>
                            Beratung bei Wechseljahrsbeschwerden
                        </p>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <b>Besonderheiten:</b>
                        <p>
                            First Trimester Screening mit Nackenfaltenmessung<br/>
                            3D/ 4D-Ultraschall und Farbdopplersonographie<br/>
                            Brustultraschall<br/>
                            Psychosomatische Grundversorgung<br/>
                            Onkologie<br/>
                            Diagnostik und Therapie bei Harninkontinenz<br/>
                            Operationen ambulant und stationär
                        </p>
                    </div>
                </div>`,
            image: "/images/behandlungsschwerpunkte.jpg",
            morelink: "",
        },
    ],
    focus_title: "",
    focus_columns: 4,
    contact: {
        title: "Kontakt & Anfahrt",
        map: {
            lat: "",
            lng: "",
        },
    },
    contact_form: {
        hidden: true,
        image: "/images/logo-large.jpg",
        first_and_lastname: "",
        telephone: "",
        email: "",
        message: "",
        submit: "",
    },
    image_slider: {
        hidden: true,
        title: "Impressionen aus unserer Frauenarztpraxis",
        images_per_page: 3,
        images: [
            "/images/slider/slider-1.jpg",
            // "/images/slider/slider-2.jpg",
            "/images/slider/slider-3.jpg",
            "/images/slider/slider-4.jpg",
            "/images/slider/slider-5.jpg",
            "/images/slider/slider-6.jpg",
            "/images/slider/slider-7.jpg",
            "/images/slider/slider-8.jpg",
            "/images/slider/slider-9.jpg",
            "/images/slider/slider-10.jpg",
            "/images/slider/slider-11.jpg",
            "/images/slider/slider-12.jpg",
            "/images/slider/slider-13.jpg",
        ],
    },
    image_slider_employees: {
        hidden: true,
        title: "Unser Praxisteam",
        images_per_page: 3,
        images: [
            "/images/slider_employees/barz.jpg",
            "/images/slider_employees/grossmann.jpg",
            "/images/slider_employees/kremer.jpg",
            "/images/slider_employees/pfau-blank.jpg",
            "/images/slider_employees/riessler.jpg",
            // '/images/slider_employees/frau_kewerhoff.jpg',
            "/images/slider_employees/crull.jpg",
            "/images/slider_employees/schorbe.jpg",
            "/images/slider_employees/kosan.jpg",
            "/images/slider_employees/matthiessen.png",
        ],
    },
    retirement_notice: {
        image: "/images/team.jpg",
    },
    impressum: `<p>
            <b>Dr. med. Regina Hoffmann</b> <br>
            Frauenärztin, Deutschland
        </p>
        <p>
            <b>Dr. med. Sabine Arndt</b> <br>
            Frauenärztin, Deutschland
        </p>
        <p>
            <b>Frau Franziska Szuba</b> <br>
            Frauenärztin, Deutschland
        </p>
        <p>
            <b>Dr. med. Sebastian Koch</b> <br>
            Frauenarzt, Deutschland
        </p>
        <p>
            Barckhausenstraße 57<br>
            21335 Lüneburg<br>
        </p>
        <p>
            Telefon: 04131 741 200<br>
            Telefax: 04131 741 153<br>
            Email: <a href='mailto:info@frauenarzt-in-lueneburg.de'>info@frauenarzt-in-lueneburg.de</a><br>
        </p>
        <p>
            <b>Ärztekammer:</b> Niedersachsen <br>
            <b>Kassenärztliche Vereinigung:</b> Niedersachsen
        </p>
        <p>
            Die nachstehenden Verlinkungen führen Sie zu der Webseite der angegebenen (Landes-)Ärztekammer und Kassenärztlichen Vereinigung (KV). Auf der Webseite der (Landes-)Ärztekammer finden Sie auch die geltenden berufsrechtlichen Regelungen.
        </p>
        <ul>
            <li><a href="http://www.bundesaerztekammer.de/ueber-uns/landesaerztekammern/adressen/">Bundesdeutschen (Landes-)Ärztekammern</a></li>
            <li><a href="http://www.frauenaerzte-im-netz.de/de_aerztekammern_721.html">Kassenärztlichen Vereinigungen (KV)</a></li>
        </ul>
        <br />
        <br />
        <br />
        <h2>Haftungsausschluss</h2>
        <p>
            Die Inhalte auf der Webseite wurden sorgfältig überprüft und beruhen auf dem jeweils aktuellen Stand. Der Anbieter behält sich vor, die eingestellten Daten und Informationen jederzeit und ohne Vorankündigung zu bearbeiten und zu aktualisieren. Trotz ständiger Überarbeitung der Webseite kann keine Haftung oder Garantie für Aktualität, Richtigkeit und Vollständigkeit der bereitgestellten Informationen übernommen werden. Die auf der Webseite zur Verfügung gestellten Dokumente und Grafiken können Ungenauigkeiten und typografische Fehler enthalten.
        </p>
        <p>
            Die Inhalte der Webseite sind ausschließlich zu Informationszwecken bestimmt. Die Informationen stellen in keinerweise Ersatz für professionelle Beratungen oder Behandlungen durch den ausgebildeten Facharzt bzw. Fachärztin dar. Die Inhalte dürfen und können nicht für die Erstellung eigenständiger Diagnosen oder für die Auswahl und Anwendung von Behandlungsmethoden verwendet werden.
            Für Schäden oder Unannehmlichkeiten, die durch den Gebrauch oder Missbrauch dieser Informationen entstehen, kann die Praxis nicht - weder direkt noch indirekt - zur Verantwortung gezogen werden.
        </p>
        <p>
            Trotz sorgfältiger inhaltlicher Kontrolle übernimmt der Anbieter keine Haftung
            für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind
            ausschließlich deren Betreiber verantwortlich.
        </p>
        <br />
        <br />
        <br />
        <h2>Datenschutzerklärung</h2>
        <p>
            Der Schutz Ihrer personenbezogenen Daten bei der Erhebung, Verarbeitung und Nutzung anlässlich Ihres Besuchs auf der Homepage ist dem Anbieter ein wichtiges Anliegen. Ihre Daten werden im Rahmen der gesetzlichen Vorschriften geschützt. Nachfolgend finden Sie Informationen, welche Daten während Ihres Besuchs auf der Homepage erfasst und wie diese genutzt werden:
        </p>
        <ol>
            <li>
                <b>Erhebung und Verarbeitung von Daten</b>
                <p>
                    Jeder Zugriff auf die Homepage des Anbieters und jeder Abruf einer auf der Homepage hinterlegten Datei werden protokolliert. Die Speicherung dient internen systembezogenen und statistischen Zwecken. Protokolliert werden: Name der abgerufenen Datei, Datum und Uhrzeit des Abrufs, übertragene Datenmenge, Meldung über erfolgreichen Abruf, Webbrowser und anfragende Domain. Zusätzlich werden die IP Adressen der anfragenden Rechner protokolliert.
                </p>
                <p>
                    Weitergehende personenbezogene Daten werden nur erfasst, wenn Sie diese Angaben freiwillig, etwa im Rahmen einer Anfrage machen. Die Registrierung bei Services wie z.B. dem Schwangerschafts-Newsletter oder Erinnerungsdiensten unterliegen den AGBs und Datenschutzerklärung von www.frauenaerzte-im-netz.de.
                </p>
            </li>
            <li>
                <b>Nutzung und Weitergabe personenbezogener Daten</b>
                <p>
                    Soweit Sie dem Anbieter personenbezogene Daten zur Verfügung gestellt haben, verwendt er diese nur zur Beantwortung Ihrer Anfragen. Ihre personenbezogenen Daten werden nicht an Dritte weitergegeben oder sonst übermittelt. Sie haben das Recht, Ihre Einwilligung zur Nutzung der Daten jederzeit mit Wirkung für die Zukunft zu widerrufen. Die Löschung der gespeicherten personenbezogenen Daten erfolgt, wenn Sie Ihre Einwilligung zur Speicherung widerrufen, wenn ihre Kenntnis zur Erfüllung des mit der Speicherung verfolgten Zwecks nicht mehr erforderlich ist oder wenn ihre Speicherung aus sonstigen gesetzlichen Gründen unzulässig ist.
                </p>
            </li>
            <li>
                <b>Auskunftsrecht</b>
                <p>
                    Auf schriftliche Anfrage wird der Anbieter Sie gern über die zu Ihrer Person gespeicherten Daten informieren.
                </p>
            </li>
        </ol>
        <b>Sicherheitshinweis:</b>
        Der Anbieter ist bemüht, Ihre personenbezogenen Daten durch Ergreifung aller technischen und organisatorischen Möglichkeiten so zu speichern, dass sie für Dritte nicht zugänglich sind. Bei der Kommunikation per E-Mail kann die vollständige Datensicherheit vom Anbieter nicht gewährleistet werden, so dass der Anbieter Ihnen bei vertraulichen Informationen den Postweg empfiehlt.
        `,
    ausbildung_fachangestellte: `
            <p>
                Sie sind ein Organisationstalent? Sie sind empathisch und arbeiten gerne mit Menschen? Sorgfalt und Verantwortungsbewusstsein sind Ihnen wichtig? Sie interessieren sich für den medizinischen Bereich?
            </p>
            <p>
                Unsere Praxis für Frauenheilkunde sucht eine engagierte und motivierte Auszubildende zur Medizinischen Fachangestellten (m/w/d).
            </p>
            <p>
                <span>Über uns:</span> Willkommen in der Frauenarztpraxis im Roten Feld, einer etablierten und patientenorientierten Praxis in Lüneburg. Unser engagiertes Team von Fachärzten ist stolz darauf, Frauen in allen Lebensphasen die bestmögliche medizinische Betreuung in den Bereichen Frauenheilkunde und Geburtshilfe anzubieten. Mit unseren modernen Einrichtungen und Dienstleistungen setzen wir uns leidenschaftlich für die Gesundheit unserer Patientinnen ein.
            </p>
            <p>
                <span class="jobs-subLine">Ihre Aufgaben:</span>
                <ul>
                    <li>Assistenz bei gynäkologischen Untersuchungen und Behandlungen</li>
                    <li>Durchführung von Laboruntersuchungen</li>
                    <li>Patientenbetreuung und -aufklärung</li>
                    <li>Verwaltung von Patientenakten und Dokumentation</li>
                    <li>Termin- und Organisationsmanagement</li>
                </ul>
            </p>
            <p>
                <span class="jobs-subLine">Was wir bieten:</span>
                <ul>
                    <li>Eine abwechslungsreiche Tätigkeit in einer renommierten Frauenarztpraxis</li>
                    <li>Ein freundliches und kollegiales Arbeitsumfeld</li>
                    <li>Faire Bezahlung und attraktive Arbeitszeiten</li>
                    <li>Die Möglichkeit, in einem Team von Fachärzten mit breitem Fachwissen zu arbeiten</li>
                </ul>
            </p>
            <p>
                <span class="jobs-subLine">Besonderheiten unserer Praxis:</span>
                <ul>
                    <li>Zeitgemäße Schwangerschaftsvorsorge und Pränataldiagnostik</li>
                    <li>First Trimester Screening mit Nackenfaltenmessung</li>
                    <li>3D/4D-Ultraschall und Farbdopplersonographie</li>
                    <li>Brust-Diagnostik</li>
                </ul>
            </p>
            <p>
                <span class="jobs-subLine">Ihr Profil:</span>
                <ul>
                    <li>Abgeschlossener Schulabschluss (mindestens Realschulabschluss)</li>
                    <li>Interesse an medizinischen und pflegerischen Tätigkeiten</li>
                    <li>Empathie und respektvoller Umgang mit Patientinnen und Patienten</li>
                    <li>Teamfähigkeit und Engagement</li>
                    <li>Zuverlässigkeit und Verantwortungsbewusstsein</li>
                    <li>Gute kommunikative Fähigkeiten</li>
                </ul>
            </p>
            <p>
                Wenn Sie Teil unseres engagierten Teams werden möchten und Interesse an einer fundierten Ausbildung in einer modernen Frauenarztpraxis haben, freuen wir uns auf Ihre vollständigen Bewerbungsunterlagen.
            </p>
            <p>
                <span>Bewerbungsinformationen:</span> Bitte senden Sie Ihre vollständigen Bewerbungsunterlagen, einschließlich Lebenslauf und Anschreiben, an die folgende Adresse:
            </p>
            <p>
                Frauenarztpraxis im Roten Feld<br />
                Barckhausenstraße 57<br />
                21335 Lüneburg<br />
                Tel. 04131 741 200<br />
                Oder per E-Mail an: <a href="mailto:info@frauenarzt-in-lueneburg.de">info@frauenarzt-in-lueneburg.de</a>
            </p>
            <p>
                Wir werden Ihre Bewerbung sorgfältig prüfen und uns bei Ihnen melden, um weitere Schritte zu besprechen. Reichen Sie bitte nur Kopien Ihrer Nachweisdokumente ein, da die eingesendete Bewerbungsunterlagen nicht zurück geschickt werden. Vielen Dank für Ihr Interesse an einer Mitarbeit in unserer Praxis.
            </p>
            <br /> <br/> <br />
            `,
    medizinische_fachangestellte: `
            <p>
                Sie sind ein Organisationstalent? Sie sind empathisch und arbeiten gerne mit Menschen? Sorgfalt und Verantwortungsbewusstsein sind Ihnen wichtig?
            </p>
            <p>
                Unsere Praxis für Frauenheilkunde sucht eine engagierte und motivierte Mitarbeiterin als Medizinische Fachangestellte (m/w/d).
            </p>
            <p>
                <span>Über uns:</span> Willkommen in der Frauenarztpraxis im Roten Feld, einer etablierten und patientenorientierten Praxis in Lüneburg. Unser engagiertes Team von Fachärzten ist stolz darauf, Frauen in allen Lebensphasen die bestmögliche medizinische Betreuung in den Bereichen Frauenheilkunde und Geburtshilfe anzubieten. Mit unseren modernen Einrichtungen und Dienstleistungen setzen wir uns leidenschaftlich für die Gesundheit unserer Patientinnen ein.
            </p>
            <p>
                <span class="jobs-subLine">Ihre Aufgaben:</span>
                <ul>
                    <li>Empfang und Betreuung der Patientinnen in unserer freundlichen Praxis</li>
                    <li>Unterstützung bei gynäkologischen Untersuchungen und Eingriffen</li>
                    <li>Durchführung von Laboruntersuchungen</li>
                    <li>Blutentnahmen und Injektionen</li>
                    <li>Patientenaktenverwaltung, Dokumentation und Terminplanung</li>
                    <li>Enge Zusammenarbeit mit einem kollegialen Team</li>
                </ul>
            </p>
            <p>
                <span class="jobs-subLine">Was wir bieten:</span>
                <ul>
                    <li>Ein freundliches und familiäres Arbeitsumfeld</li>
                    <li>Eine abwechslungsreiche Tätigkeit in einer renommierten Frauenarztpraxis</li>
                    <li>Faire Bezahlung und attraktive Arbeitszeiten</li>
                    <li>Die Möglichkeit, in einem Team von Fachärzten mit breitem Fachwissen zu arbeiten</li>
                </ul>
            </p>
            <p>
                <span class="jobs-subLine">Besonderheiten unserer Praxis:</span>
                <ul>
                    <li>First Trimester Screening mit Nackenfaltenmessung</li>
                    <li>3D/4D-Ultraschall und Farbdopplersonographie</li>
                    <li>Brust-Diagnostik</li>
                    <li>Psychosomatische Grundversorgung</li>
                </ul>
            </p>
            <p>
                <span class="jobs-subLine">Ihr Profil:</span>
                <ul>
                    <li>Idealerweise abgeschlossene Ausbildung zur Medizinischen Fachangestellten (MFA) oder artverwandte Qualifikation</li>
                    <li>Teamfähigkeit und einfühlsame Persönlichkeit</li>
                    <li>Hohes Maß an Verantwortungsbewusstsein und Engagement</li>
                    <li>Bereitschaft zur Weiterbildung und zur Anpassung an neue Technologien</li>
                    <li>Erfahrung im Bereich Frauenheilkunde oder Geburtshilfe ist von Vorteil, aber nicht zwingend erforderlich</li>
                </ul>
            </p>
            <p>
                Wenn Sie sich für eine spannende und erfüllende Position in unserer Frauenarztpraxis in Lüneburg interessieren und die Möglichkeit sehen, einen positiven Beitrag zur Frauen- und Gesundheitsversorgung zu leisten, freuen wir uns auf Ihre Bewerbung!
            </p>
            <p>
                <span>Bewerbungsinformationen:</span> Bitte senden Sie Ihre vollständigen Bewerbungsunterlagen, einschließlich Lebenslauf und Anschreiben, an die folgende Adresse:
            </p>
            <p>
                Frauenarztpraxis im Roten Feld<br />
                Barckhausenstraße 57<br />
                21335 Lüneburg<br />
                Tel. 04131 741 200<br />
                Oder per E-Mail an: <a href="mailto:info@frauenarzt-in-lueneburg.de">info@frauenarzt-in-lueneburg.de</a>
            </p>
            <p>
                Wir werden Ihre Bewerbung sorgfältig prüfen und uns bei Ihnen melden, um weitere Schritte zu besprechen. Vielen Dank für Ihr Interesse an einer Mitarbeit in unserer Praxis.
            </p>

        `,
    jobsLink: `
        <h3 class="jobsLink-headline">Ausbildung Medizinische/r Fachangestellte/r (m/w/d) ab dem 01.08.2025 </h3> 
    `,
    jobsLink2: `
        <h3 class="jobsLink-headline">Medizinische Fachangestellte (m/w/d) gesucht </h3>
    `,
};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/mainReducer.js